// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const legAnalysisAPI = createApi({
  reducerPath: 'legAnalysisAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['legAnalysis'],
  endpoints: (builder) => ({
    getLegAnalysisList: builder.query<any, any>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/analysis/leg`,
        method: 'GET',
      }),
      providesTags: ['legAnalysis'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLegAnalysisListQuery } = legAnalysisAPI;
